import { Box } from '@rulebooks/evidend-titan';
import { Trans } from '@lingui/macro';
import React from 'react';

export const GlobalSuccessMessages = ({
  messages,
}: {
  messages: Array<{ key: string; message: string }>;
}) => {
  if (messages.length > 1) {
    return (
      <Box pl={2}>
        <Trans>De volgende wijzigingen zijn opgeslagen:</Trans>
        <ul>
          {messages.map(({ key, message }) => (
            <li key={key}>{message}</li>
          ))}
        </ul>
      </Box>
    );
  }
  if (messages.length === 1) {
    return <Box pl={2}>{messages[0].message}</Box>;
  }
  return <Trans>Wijzigingen opgeslagen</Trans>;
};
